import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import Image from "../../../../../../base/multimedia/image/index.js";
import * as S from "../styled.js";
export const NormalMasonryCard = ({ image , title , description , width , height , cardTitleVariant  })=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            image && /*#__PURE__*/ _jsx(Image, {
                ...image,
                width,
                height,
                resize: {
                    width,
                    height
                },
                isLazy: true
            }),
            /*#__PURE__*/ _jsxs(S.MasonryCardBody, {
                className: classNames([
                    cardTitleVariant
                ]),
                children: [
                    title && /*#__PURE__*/ _jsx(S.MasonryCardTitle, {
                        children: title
                    }),
                    description && /*#__PURE__*/ _jsx(S.MasonryCardDescription, {
                        children: description
                    })
                ]
            })
        ]
    });
export default NormalMasonryCard;

//# sourceMappingURL=normalMasonryCard.js.map